// extracted by mini-css-extract-plugin
module.exports = {"admin":"Admin_admin__1L3VW","toolbar":"Admin_toolbar__1Rcjf","tabs":"Admin_tabs__Eb4HT"};